/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from 'react';
var TooltipContext = /*#__PURE__*/createContext(null);
export default TooltipContext;